import React, {Component} from 'react';
import Cookie from 'js-cookie';
import LoginForm from '../auth/login-form';
import PasswordReset from '../auth/password-reset';
import RegistrationForm from '../auth/registration-form';
import RequestPasswordReset from '../auth/request-password-reset';
import ProjectList from './project-list';
import {logOutLinkStyle} from '../styles';

export default class MembersArea extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: Cookie.get('cbadviser-user') !== undefined,
            requiresPasswordReset: false,
            registrationTabSelected: true,
            showRequestPasswordReset: false
        };
    }

    logOut = () => {
        Cookie.remove('cbadviser-user');
        this.setState({isAuthenticated: false});
    };

    render() {
        if (this.state.isAuthenticated) {
            if (this.state.requiresPasswordReset) {
                return <PasswordReset onReset={() => this.setState({requiresPasswordReset: false})}/>
            } else {
                return (
                    <div>
                        <div className="pull-right"><a href="#" onClick={this.logOut} style={logOutLinkStyle}>Log out</a></div>
                        <ProjectList/>
                    </div>
                )
            }
        } else if (this.state.showRequestPasswordReset) {
            return <RequestPasswordReset onCancel={() => this.setState({showRequestPasswordReset: false})}/>
        } else {
            const content =
                this.state.registrationTabSelected
                    ? <RegistrationForm redirectToLogin={() => this.setState({registrationTabSelected: false})}/>
                    : <LoginForm onLogIn={requiresPasswordReset => this.setState({isAuthenticated: true, requiresPasswordReset: requiresPasswordReset})}/>;

            return (
                <div>
                    <ul className="nav nav-tabs" style={{marginBottom: '20px'}}>
                        <li className={this.state.registrationTabSelected ? 'active' : ''}><a className="clickable" onClick={() => this.setState({registrationTabSelected: true})}>Registration</a></li>
                        <li className={this.state.registrationTabSelected ? '' : 'active'}><a className="clickable" onClick={() => this.setState({registrationTabSelected: false})}>Login</a></li>
                    </ul>
                    {content}
                </div>);
        }
    }
}


// WEBPACK FOOTER //
// ./src/members/members-area.js